<dt-table-layout *dtDataLoad="true; error: hasError" [isLoading]="isLoading">
  <form header class="filters-form" [formGroup]="filterForm" (ngSubmit)="triggerLoadSubject.next()">
    <mat-form-field class="search-query dt-no-margin">
      <mat-label i18n>Suche</mat-label>
      <input type="text" formControlName="searchQuery" matInput />
      <mat-icon
        matSuffix
        matTooltip="Sucht nach Nutzern mit dem gegebenen Text in E-Mail oder nach (vollständiger) Abgabe-ID"
        i18n-matTooltip
        >info</mat-icon
      >
    </mat-form-field>
    <mat-radio-group formControlName="projectSubmitted">
      <mat-label i18n>Projekt abgegeben</mat-label>
      <mat-radio-button value="ignore" i18n>Egal</mat-radio-button>
      <mat-radio-button [value]="true" i18n>Ja</mat-radio-button>
      <mat-radio-button [value]="false" i18n>Nein</mat-radio-button>
    </mat-radio-group>
  </form>

  <table
    mat-table
    [dataSource]="eventRegistrations"
    class="mat-elevation-z8"
    matSort
    [matSortDisableClear]="true"
    [matSortActive]="sort.sortBy"
    [matSortDirection]="sort.sortDirection"
    (matSortChange)="onSortChange($event)"
    [dtOverlayProgress]="atLeastOneActionPending$ | async"
  >
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>E-Mail</th>
      <td mat-cell *matCellDef="let eventRegistration"> {{ eventRegistration.user.email }} </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Abgabe-ID</th>
      <td mat-cell *matCellDef="let eventRegistration"> {{ eventRegistration.id }} </td>
    </ng-container>
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Zuletzt bearbeitet</th>
      <td mat-cell *matCellDef="let eventRegistration"> {{ eventRegistration.updatedAt | date: 'medium' }} </td>
    </ng-container>
    <ng-container matColumnDef="submitted">
      <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>Abgegeben</th>
      <td mat-cell *matCellDef="let eventRegistration" i18n>
        <mat-icon>{{ eventRegistration.submitted ? 'done' : 'close' }}</mat-icon>
      </td></ng-container
    >

    <ng-container matColumnDef="showProject">
      <th mat-header-cell *matHeaderCellDef i18n>Aktionen</th>
      <td mat-cell *matCellDef="let eventRegistration">
        <button
          mat-icon-button
          color="primary"
          [disabled]="!eventRegistration.submitted"
          (click)="showProject(eventRegistration, $event)"
          i18n
        >
          <mat-icon>preview</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          [disabled]="!eventRegistration.submitted"
          (click)="exportProject(eventRegistration, $event)"
        >
          <mat-icon>file_download</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="['email', 'id', 'updatedAt', 'submitted', 'showProject']; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let eventRegistration; columns: ['email', 'id', 'updatedAt', 'submitted', 'showProject']"
      (click)="openEventRegistrationInformationModal(eventRegistration)"
    ></tr>
  </table>

  <mat-paginator
    [pageSize]="page.pageSize"
    [pageIndex]="page.pageIndex"
    [length]="totalNumberOfParticipants"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)"
  ></mat-paginator>
</dt-table-layout>
